
export default {
    name: 't-neighborhood-page',
};
